import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from '../../../service/ajax.service';
import { UtilService } from '../../../service/util.service';
import { API } from '../../../../environments/environment';
import { UserService } from 'src/app/services/user.service';

interface Atendimento {
  id: number;
  idConsultaEnc: string;
  idTipoConsulta: number;
  idTipoSituacao: number;
  idTipoStatus: number;
  sobrenome: string;
  cliente: string;
  data: Date;
  horaInicio: string;
  horaFim: string;
  tipo: string;
  onlinePresencial: string;
  reuniao: string;
  situacao: string;
  statusAgendamento: string;
}

interface SituacaoOpcao {
  id: number;
  nome: string;
}

interface StatusAgendamentoOpcao {
  id: number;
  nome: string;
}

interface LinkMeetingInfo {
  roomName: string;
  status: string;
  endDate: string;
  hostUrl: string;
  clienteUrl: string;
}

interface Filtros {
  cliente: string;
  tipo: string; // idTipoConsulta
  onlinePresencial: string;
  situacao: string;
  statusAgendamento: string;
  dataInicio: string;
  dataFim: string;
}

@Component({
  selector: 'app-consultar-atendimentos',
  templateUrl: './consultar-atendimentos.component.html',
  styleUrls: ['./consultar-atendimentos.component.scss']
})
export class ConsultarAtendimentosComponent implements OnInit {

  atendimentos: Atendimento[] = [];
  atendimentosFiltrados: Atendimento[] = [];
  atendimentosPaginados: Atendimento[] = [];
  loading = false;
  paginaAtual = 1;
  itensPorPagina = 15;
  totalPaginas = 0;
  Math = Math;
  isArrastandoTabela = false;
  private scrollStartX = 0;
  private scrollStartLeft = 0;
  private pendingRequests = 0;

  filtros: Filtros = {
    cliente: '',
    tipo: '',
    onlinePresencial: '',
    situacao: '',
    statusAgendamento: '',
    dataInicio: '',
    dataFim: ''
  };

  tiposAtendimento: { id: number; nome: string }[] = [];
  situacoesAtendimento: SituacaoOpcao[] = [];
  statusAgendamentoOpcoes: StatusAgendamentoOpcao[] = [];
  exibirModalSituacao = false;
  exibirModalStatusAgendamento = false;
  exibirModalLinkMeeting = false;
  atendimentoSelecionado: Atendimento | null = null;
  atendimentoLinkMeetingSelecionado: Atendimento | null = null;
  meetingInfo: LinkMeetingInfo | null = null;
  carregandoLinkMeeting = false;
  novaSituacaoId: number | null = null;
  novoStatusId: number | null = null;
  salvandoSituacao = false;
  salvandoStatus = false;

  constructor(
    private router: Router,
    private ajaxService: AjaxService,
    private util: UtilService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.carregarTiposAtendimento();
    this.carregarSituacoesAtendimento();
    this.carregarStatusAgendamento();
    this.carregarAtendimentos();
  }

  carregarAtendimentos(): void {
    const payload = {
      nomePaciente: this.filtros.cliente || null,
      idTipoConsulta: this.filtros.tipo ? Number(this.filtros.tipo) : null,
      presencialOnline: this.filtros.onlinePresencial
        ? (this.filtros.onlinePresencial.toLowerCase() === 'presencial' ? 'P' : 'O')
        : null,
      situacao: this.filtros.situacao || null,
      statusAgendamento: this.filtros.statusAgendamento || null,
      dataInicio: this.filtros.dataInicio || null,
      dataFim: this.filtros.dataFim || null
    };

    this.iniciarLoading();

    this.ajaxService.post(API + 'empresa/Consulta/Consultar', payload).subscribe({
      next: (response) => {
        this.finalizarLoading();

        const lista = response?.data && Array.isArray(response.data) ? response.data : [];
        this.atendimentos = lista
          .filter((item: any) => item && typeof item === 'object')
          .map((item: any) => this.util.converterParaLowercase(item))
          .map((item: any) => this.mapearAtendimento(item));

        this.atendimentosFiltrados = [...this.atendimentos];
        this.paginaAtual = 1;
        this.atualizarPaginacao();
      },
      error: () => {
        this.finalizarLoading();
        this.atendimentos = [];
        this.atendimentosFiltrados = [];
        this.atendimentosPaginados = [];
        this.totalPaginas = 0;
        this.util.toasterShowError('Erro', 'Erro ao carregar atendimentos');
      }
    });
  }

  carregarTiposAtendimento(): void {
    this.iniciarLoading();
    this.ajaxService.get(API + 'empresa/TipoConsulta/Consultar').subscribe({
      next: (response) => {
        this.finalizarLoading();
        const lista = response?.data && Array.isArray(response.data) ? response.data : [];
        this.tiposAtendimento = lista
          .map((item: any) => this.util.converterParaLowercase(item))
          .filter((item: any) => item?.id && item?.descricao)
          .map((item: any) => ({
            id: Number(item.id),
            nome: item.descricao
          }));
      },
      error: () => {
        this.finalizarLoading();
        this.tiposAtendimento = [];
      }
    });
  }

  private mapearAtendimento(item: any): Atendimento {
    const data = item.data ? new Date(item.data) : new Date();
    const onlinePresencial = (item.presencial_online || '').toUpperCase() === 'P' ? 'Presencial' : 'Online';

    return {
      id: Number(item.idconsulta || 0),
      idConsultaEnc: item.idconsultaenc || '',
      idTipoConsulta: Number(item.idtipoconsulta || 0),
      idTipoSituacao: Number(item.idtiposituacao || 0),
      idTipoStatus: Number(item.idtipostatus || 0),
      sobrenome: item.sobrenomecliente || '',
      cliente: item.nomepaciente || '',
      data,
      horaInicio: item.horaformatada || '',
      horaFim: item.horafimformatada || '',
      tipo: item.tipo || '',
      onlinePresencial,
      reuniao: item.statusmeeting || '-',
      situacao: item.situacao || '-',
      statusAgendamento: item.status || '-'
    };
  }

  aplicarFiltros(): void {
    // Filtros principais são aplicados no backend.
    this.carregarAtendimentos();
  }

  pesquisarAtendimentos(): void {
    this.aplicarFiltros();
  }

  limparFiltros(): void {
    this.filtros = {
      cliente: '',
      tipo: '',
      onlinePresencial: '',
      situacao: '',
      statusAgendamento: '',
      dataInicio: '',
      dataFim: ''
    };
    this.carregarAtendimentos();
  }

  verDetalhes(atendimento: Atendimento): void {
    if (!atendimento.idConsultaEnc) return;
    this.router.navigate(['/agendar-atendimento'], {
      queryParams: {
        idConsulta: atendimento.idConsultaEnc
      }
    });
  }

  editarAtendimento(atendimento: Atendimento): void {
    this.verDetalhes(atendimento);
  }

  abrirArvoreGenealogica(atendimento: Atendimento): void {
    if (!atendimento?.idConsultaEnc) {
      this.util.toasterShowError('Atenção', 'Atendimento inválido para abrir a árvore genealógica.');
      return;
    }

    this.router.navigate(['/arvore-genealogica'], {
      queryParams: {
        idConsulta: atendimento.idConsultaEnc
      }
    });
  }

  abrirDocumentos(atendimento: Atendimento): void {
    if (!atendimento?.idConsultaEnc) {
      this.util.toasterShowError('Atenção', 'Atendimento inválido para abrir documentos.');
      return;
    }

    this.router.navigate(['/documentos-consulta'], {
      queryParams: {
        idConsulta: atendimento.idConsultaEnc
      }
    });
  }

  abrirUploadDocumentos(atendimento: Atendimento): void {
    if (!atendimento?.idConsultaEnc) {
      this.util.toasterShowError('Atenção', 'Atendimento inválido para upload de documentos.');
      return;
    }

    this.router.navigate(['/upload-documentos-consulta'], {
      queryParams: {
        idConsulta: atendimento.idConsultaEnc
      }
    });
  }

  abrirVisualizacaoFormulario(atendimento: Atendimento): void {
    if (!atendimento?.idConsultaEnc || !atendimento?.idTipoConsulta) {
      this.util.toasterShowError('Atenção', 'Atendimento inválido para visualizar formulário.');
      return;
    }

    this.router.navigate(['/visualizar-formulario'], {
      queryParams: {
        idFormulario: atendimento.idConsultaEnc,
        idTipoConsulta: String(atendimento.idTipoConsulta)
      }
    });
  }

  abrirOrcamentos(atendimento: Atendimento): void {
    if (!atendimento?.idConsultaEnc) {
      this.util.toasterShowError('Atenção', 'Atendimento inválido para abrir orçamentos.');
      return;
    }

    this.router.navigate(['/orcamentos-consulta'], {
      queryParams: {
        idConsulta: atendimento.idConsultaEnc
      }
    });
  }

  abrirModalLinkMeeting(atendimento: Atendimento): void {
    if (!atendimento?.idConsultaEnc) {
      this.util.toasterShowError('Atenção', 'Atendimento inválido para abrir link da reunião.');
      return;
    }

    this.exibirModalLinkMeeting = true;
    this.atendimentoLinkMeetingSelecionado = atendimento;
    this.meetingInfo = null;
    this.carregandoLinkMeeting = true;
    this.iniciarLoading();

    this.ajaxService.get(`${API}empresa/Consulta/VerLinkMeeting?idConsulta=${encodeURIComponent(atendimento.idConsultaEnc)}`).subscribe({
      next: (response) => {
        this.finalizarLoading();
        this.carregandoLinkMeeting = false;
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível carregar os dados da reunião.');
          return;
        }

        const dados = this.util.converterParaLowercase(response?.data || {});
        if (!dados || Object.keys(dados).length === 0) {
          this.meetingInfo = null;
          return;
        }

        this.meetingInfo = {
          roomName: dados.roomname || '-',
          status: dados.status || '-',
          endDate: dados.enddate || '',
          hostUrl: dados.hosturl || '',
          clienteUrl: dados.clienteurl || ''
        };
      },
      error: () => {
        this.finalizarLoading();
        this.carregandoLinkMeeting = false;
        this.util.toasterShowError('Erro', 'Erro ao buscar link da reunião.');
      }
    });
  }

  fecharModalLinkMeeting(): void {
    this.exibirModalLinkMeeting = false;
    this.atendimentoLinkMeetingSelecionado = null;
    this.meetingInfo = null;
    this.carregandoLinkMeeting = false;
  }

  formatarDataMeeting(value: string): string {
    if (!value) return '-';
    const data = new Date(value);
    if (Number.isNaN(data.getTime())) return value;
    return data.toLocaleDateString('pt-BR');
  }

  excluirAtendimento(atendimento: Atendimento): void {
    this.util.toasterShowError('Indisponível', 'Exclusão de atendimento não implementada nesta tela.');
  }

  novoAtendimento(): void {
    this.router.navigate(['/agendar-atendimento']);
  }

  alterarSituacao(atendimento: Atendimento): void {
    this.atendimentoSelecionado = atendimento;
    this.novaSituacaoId = atendimento.idTipoSituacao > 0 ? atendimento.idTipoSituacao : null;
    this.exibirModalSituacao = true;
  }

  alterarStatusAgendamento(atendimento: Atendimento): void {
    this.atendimentoSelecionado = atendimento;
    this.novoStatusId = atendimento.idTipoStatus > 0 ? atendimento.idTipoStatus : null;
    this.exibirModalStatusAgendamento = true;
  }

  getSituacaoClass(situacao: string): string {
    switch ((situacao || '').toLowerCase()) {
      case 'a confirmar': return 'badge bg-warning';
      case 'primeiro atend': return 'badge bg-primary';
      case 'finalizado': return 'badge bg-success';
      case 'recebido': return 'badge bg-info';
      case 'processo': return 'badge bg-secondary';
      case 'cancelado': return 'badge bg-danger';
      default: return 'badge bg-light text-dark';
    }
  }

  getStatusAgendamentoClass(status: string): string {
    switch ((status || '').toLowerCase()) {
      case 'recebido': return 'badge bg-primary';
      case 'a confirmar': return 'badge bg-warning';
      case 'confirmado': return 'badge bg-success';
      case 'cancelado': return 'badge bg-danger';
      case 'finalizado': return 'badge bg-info';
      case 'desistência': return 'badge bg-secondary';
      case 'desistencia': return 'badge bg-secondary';
      default: return 'badge bg-light text-dark';
    }
  }

  getTipoClass(tipo: string): string {
    switch ((tipo || '').toLowerCase()) {
      case 'processo judicial na itália': return 'badge bg-danger';
      case 'análise de documentos': return 'badge bg-primary';
      case 'cadastro consular (fast it)': return 'badge bg-success';
      case 'preparação de documentos': return 'badge bg-warning';
      default: return 'badge bg-light text-dark';
    }
  }

  getOnlinePresencialClass(tipo: string): string {
    switch ((tipo || '').toLowerCase()) {
      case 'online': return 'badge bg-success';
      case 'presencial': return 'badge bg-primary';
      default: return 'badge bg-light text-dark';
    }
  }

  getReuniaoClass(reuniao: string): string {
    switch ((reuniao || '').toLowerCase()) {
      case 'sala fechada': return 'badge bg-danger';
      case 'atendido': return 'badge bg-success';
      case 'em atendimento': return 'badge bg-warning';
      default: return 'badge bg-light text-dark';
    }
  }

  atualizarPaginacao(): void {
    const totalItens = this.atendimentosFiltrados.length;
    this.totalPaginas = Math.ceil(totalItens / this.itensPorPagina);

    if (this.totalPaginas === 0) {
      this.paginaAtual = 1;
      this.atendimentosPaginados = [];
      return;
    }

    if (this.paginaAtual > this.totalPaginas) {
      this.paginaAtual = this.totalPaginas;
    }

    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    const fim = inicio + this.itensPorPagina;
    this.atendimentosPaginados = this.atendimentosFiltrados.slice(inicio, fim);
  }

  paginaAnterior(): void {
    if (this.paginaAtual <= 1) return;
    this.paginaAtual--;
    this.atualizarPaginacao();
  }

  proximaPagina(): void {
    if (this.paginaAtual >= this.totalPaginas) return;
    this.paginaAtual++;
    this.atualizarPaginacao();
  }

  iniciarArrasteTabela(event: MouseEvent, container: HTMLElement): void {
    const target = event.target as HTMLElement | null;
    if (target && target.closest('button, a, input, select, textarea, label')) return;

    this.isArrastandoTabela = true;
    this.scrollStartX = event.pageX - container.offsetLeft;
    this.scrollStartLeft = container.scrollLeft;
  }

  moverArrasteTabela(event: MouseEvent, container: HTMLElement): void {
    if (!this.isArrastandoTabela) return;
    event.preventDefault();

    const x = event.pageX - container.offsetLeft;
    const walk = x - this.scrollStartX;
    container.scrollLeft = this.scrollStartLeft - walk;
  }

  finalizarArrasteTabela(): void {
    this.isArrastandoTabela = false;
  }

  private iniciarLoading(): void {
    this.pendingRequests++;
    if (this.pendingRequests === 1) {
      this.loading = true;
      this.util.showLoading();
    }
  }

  private finalizarLoading(): void {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    if (this.pendingRequests === 0) {
      this.loading = false;
      this.util.closeLoading();
    }
  }

  carregarSituacoesAtendimento(): void {
    this.iniciarLoading();
    this.ajaxService.get(API + 'empresa/Consulta/ConsultarSituacoes').subscribe({
      next: (response) => {
        this.finalizarLoading();
        const lista = response?.data && Array.isArray(response.data) ? response.data : [];
        this.situacoesAtendimento = lista
          .map((item: any) => this.util.converterParaLowercase(item))
          .filter((item: any) => item?.id && item?.descricao)
          .map((item: any) => ({
            id: Number(item.id),
            nome: item.descricao
          }));

        if (this.situacoesAtendimento.length === 0) {
          this.situacoesAtendimento = this.getSituacoesFallback();
        }
      },
      error: () => {
        this.finalizarLoading();
        this.situacoesAtendimento = this.getSituacoesFallback();
      }
    });
  }

  carregarStatusAgendamento(): void {
    this.iniciarLoading();
    this.ajaxService.get(API + 'empresa/Consulta/ConsultarStatusAgendamento').subscribe({
      next: (response) => {
        this.finalizarLoading();
        const lista = response?.data && Array.isArray(response.data) ? response.data : [];
        this.statusAgendamentoOpcoes = lista
          .map((item: any) => this.util.converterParaLowercase(item))
          .filter((item: any) => item?.id && item?.descricao)
          .map((item: any) => ({
            id: Number(item.id),
            nome: item.descricao
          }));

        if (this.statusAgendamentoOpcoes.length === 0) {
          this.statusAgendamentoOpcoes = this.getStatusAgendamentoFallback();
        }
      },
      error: () => {
        this.finalizarLoading();
        this.statusAgendamentoOpcoes = this.getStatusAgendamentoFallback();
      }
    });
  }

  fecharModalSituacao(): void {
    if (this.salvandoSituacao) return;
    this.exibirModalSituacao = false;
    this.atendimentoSelecionado = null;
    this.novaSituacaoId = null;
  }

  fecharModalStatusAgendamento(): void {
    if (this.salvandoStatus) return;
    this.exibirModalStatusAgendamento = false;
    this.atendimentoSelecionado = null;
    this.novoStatusId = null;
  }

  salvarNovaSituacao(): void {
    if (!this.atendimentoSelecionado) return;
    if (!this.novaSituacaoId || this.novaSituacaoId <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione a nova situação.');
      return;
    }
    const idUsuarioLogado = this.getIdUsuarioLogado();
    if (!idUsuarioLogado) {
      this.util.toasterShowError('Erro', 'Usuário logado não identificado.');
      return;
    }

    const payload = {
      idConsulta: this.atendimentoSelecionado.idConsultaEnc || String(this.atendimentoSelecionado.id),
      idNovaSituacao: this.novaSituacaoId,
      idUsuarioLogado: String(idUsuarioLogado)
    };

    this.salvandoSituacao = true;
    this.iniciarLoading();
    this.ajaxService.post(API + 'empresa/Consulta/AlterarSituacao', payload).subscribe({
      next: (response) => {
        this.finalizarLoading();
        this.salvandoSituacao = false;
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível alterar a situação.');
          return;
        }

        const situacaoSelecionada = this.situacoesAtendimento.find(x => x.id === Number(this.novaSituacaoId));
        this.atendimentoSelecionado!.idTipoSituacao = Number(this.novaSituacaoId);
        if (situacaoSelecionada?.nome) {
          this.atendimentoSelecionado!.situacao = situacaoSelecionada.nome;
        }

        this.util.toasterShowSuccess('Sucesso', 'Situação alterada com sucesso!');
        this.fecharModalSituacao();
      },
      error: () => {
        this.finalizarLoading();
        this.salvandoSituacao = false;
        this.util.toasterShowError('Erro', 'Erro ao alterar situação do atendimento.');
      }
    });
  }

  salvarNovoStatusAgendamento(): void {
    if (!this.atendimentoSelecionado) return;
    if (!this.novoStatusId || this.novoStatusId <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione o novo status.');
      return;
    }
    const idUsuarioLogado = this.getIdUsuarioLogado();
    if (!idUsuarioLogado) {
      this.util.toasterShowError('Erro', 'Usuário logado não identificado.');
      return;
    }

    const payload = {
      idConsulta: this.atendimentoSelecionado.idConsultaEnc || String(this.atendimentoSelecionado.id),
      idNovoStatus: this.novoStatusId,
      idUsuarioLogado: String(idUsuarioLogado)
    };

    this.salvandoStatus = true;
    this.iniciarLoading();
    this.ajaxService.post(API + 'empresa/Consulta/AlterarStatus', payload).subscribe({
      next: (response) => {
        this.finalizarLoading();
        this.salvandoStatus = false;
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível alterar o status.');
          return;
        }

        const statusSelecionado = this.statusAgendamentoOpcoes.find(x => x.id === Number(this.novoStatusId));
        this.atendimentoSelecionado!.idTipoStatus = Number(this.novoStatusId);
        if (statusSelecionado?.nome) {
          this.atendimentoSelecionado!.statusAgendamento = statusSelecionado.nome;
        }

        this.util.toasterShowSuccess('Sucesso', 'Status alterado com sucesso!');
        this.fecharModalStatusAgendamento();
      },
      error: () => {
        this.finalizarLoading();
        this.salvandoStatus = false;
        this.util.toasterShowError('Erro', 'Erro ao alterar status do atendimento.');
      }
    });
  }

  private getSituacoesFallback(): SituacaoOpcao[] {
    return [
      { id: 1, nome: 'Primeiro Atend' },
      { id: 2, nome: 'Processo' },
      { id: 3, nome: 'Cancelado' },
      { id: 6, nome: 'Recebido' },
      { id: 7, nome: 'Finalizado' },
      { id: 8, nome: 'A Confirmar' },
      { id: 9, nome: 'Dúvida Geral' }
    ];
  }

  private getStatusAgendamentoFallback(): StatusAgendamentoOpcao[] {
    return [
      { id: 6, nome: 'Recebido' },
      { id: 8, nome: 'A Confirmar' },
      { id: 10, nome: 'Confirmado' },
      { id: 1, nome: 'Cancelado' },
      { id: 7, nome: 'Finalizado' },
      { id: 5, nome: 'Desistência' }
    ];
  }

  private getIdUsuarioLogado(): number | null {
    const userData = this.userService.getUserData();
    if (!userData) return null;

    const userId =
      Number(userData.User?.Id) ||
      Number((userData as any)?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']) ||
      0;

    return userId > 0 ? userId : null;
  }

}